<div class="flex items-center space-x-2">
  @for (s of eventStatusBadges; track s.label) {
    <div
      [class]="s.bgClass"
      class="status-badge flex items-center space-x-2 !font-normal !py-2">
      <mat-icon [class]="s.class" class="!text-sm !w-4 !h-4 !leading-4">{{ s.icon }}</mat-icon>
      <div [class]="s.class" [translateParams]="(s.labelParams | async) ?? {}" class="!text-sm"
           translate>{{ s.label }}
      </div>
    </div>
  }
</div>
